// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Uq5N","header":"MessagesList_header__2RZgO","chat":"MessagesList_chat__2MUu6"};